import { createReducer, on } from '@ngrx/store';
import * as SquareOrdersErrorsActions from './square-orders-errors.actions';
import { SquareOrderError } from './square-orders-errors.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface SquareOrdersErrorsState {
    squareOrdersErrors: SquareOrderError[];
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialSquareOrdersErrorsState: SquareOrdersErrorsState = {
    squareOrdersErrors: [],
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

export const squareOrdersErrorsReducer = createReducer(
    initialSquareOrdersErrorsState,

    on(SquareOrdersErrorsActions.loadSquareOrdersErrors, (state) => ({ ...state, isLoading: true })),
    on(SquareOrdersErrorsActions.loadSquareOrdersErrorsSuccess, (state, { squareOrdersErrors }) => ({
        ...state, isLoading: false, squareOrdersErrors,
    })),
    on(SquareOrdersErrorsActions.loadSquareOrdersErrorsFailure, (state, { error }) => ({
        ...state, isLoading: false, error,
    }))
);
